import type { IconSvgObject } from './types';

const ArrowRight01Icon: IconSvgObject = [
  ["path", { d: "M9.00005 6L15 12L9 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowRight01Icon;
